import React from 'react';
import { UserIcon, ArrowUpRightIcon, ArrowDownRightIcon } from 'lucide-react';
import type { LoanOfficer, MetricType, PeriodInfo } from '../../types';
import { ProgressBar } from '../ui/ProgressBar';
import { Badge } from '../ui/Badge';
import { getProgressPercentage, getProgressStatus, calculateProjection, getProjectionLabel } from '../../utils/calculations';
interface LoanOfficerRowProps {
  loanOfficer: LoanOfficer;
  period: PeriodInfo;
  metric: MetricType;
}
export function LoanOfficerRow({
  loanOfficer,
  period,
  metric
}: LoanOfficerRowProps) {
  const current = metric === 'softPull' ? loanOfficer.softPullCount : loanOfficer.submittedCount;
  const goal = metric === 'softPull' ? loanOfficer.softPullGoal : loanOfficer.submittedGoal;
  const percentage = getProgressPercentage(current, goal);
  const projected = calculateProjection(current, period.daysElapsed, period.totalDays);
  const projectionLabel = getProjectionLabel(projected, goal);
  const status = getProgressStatus(getProgressPercentage(projected, goal));
  const isAboveGoal = projected >= goal;
  return <div className="flex items-center gap-4 px-4 py-3.5 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors border-b border-gray-100 dark:border-gray-700 last:border-b-0" data-id="element-69">
      {/* Name */}
      <div className="flex items-center gap-3 w-44 flex-shrink-0" data-id="element-70">
        <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center flex-shrink-0" data-id="element-71">
          <UserIcon className="w-4 h-4 text-gray-500 dark:text-gray-400" data-id="element-72" />
        </div>
        <span className="text-sm font-medium text-gray-900 dark:text-white truncate" data-id="element-73">
          {loanOfficer.name}
        </span>
      </div>

      {/* Progress Bar */}
      <div className="flex-1 min-w-0" data-id="element-74">
        <ProgressBar current={current} goal={goal} size="sm" showLabel={false} data-id="element-75" />
      </div>

      {/* Count */}
      <div className="w-24 text-right flex-shrink-0" data-id="element-76">
        <span className="text-sm font-semibold text-gray-900 dark:text-white" data-id="element-77">
          {current}
        </span>
        <span className="text-sm text-gray-400 dark:text-gray-500" data-id="element-78">
          {' '}
          / {goal}
        </span>
      </div>

      {/* Percentage */}
      <div className="w-16 text-right flex-shrink-0" data-id="element-79">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-80">
          {percentage}%
        </span>
      </div>

      {/* Projection */}
      <div className="w-52 flex-shrink-0 hidden xl:flex items-center gap-2" data-id="element-81">
        {isAboveGoal ? <ArrowUpRightIcon className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-82" /> : <ArrowDownRightIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-83" />}
        <span className="text-xs text-gray-600 dark:text-gray-400 truncate" data-id="element-84">
          {projectionLabel}
        </span>
      </div>

      {/* Status Badge */}
      <div className="w-24 flex-shrink-0 flex justify-end" data-id="element-85">
        <Badge status={status} size="sm" data-id="element-86" />
      </div>
    </div>;
}